import { render, staticRenderFns } from "./thirdLogin.vue?vue&type=template&id=56e3a7a4&scoped=true&"
import script from "./thirdLogin.vue?vue&type=script&lang=js&"
export * from "./thirdLogin.vue?vue&type=script&lang=js&"
import style0 from "./thirdLogin.vue?vue&type=style&index=0&id=56e3a7a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e3a7a4",
  null
  
)

export default component.exports